import { render, staticRenderFns } from "./DiscountType.template.vue?vue&type=template&id=2d77e059&scoped=true&"
var script = {}
import style0 from "./DiscountType.template.vue?vue&type=style&index=0&id=2d77e059&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77e059",
  null
  
)

export default component.exports